import { createListenerMiddleware } from '@reduxjs/toolkit';

import { accountApi } from '@/services/account';
import { brandsApi } from '@/services/brands';
import { eCommApi } from '@/services/ecomm';
import { TransientStorageService } from '@/utils/services';

import { invalidate, syncNativeAppContext } from '../slices/appSlice';
import { setUserDidDismissOnHoldAlertAction } from '../slices/myVisitSlice';

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: syncNativeAppContext.fulfilled,
  effect: (action, { dispatch }) => {
    dispatch(brandsApi.endpoints.getBrand.initiate(action.payload.brand));
  },
});

// Tag the Datadog session with the feature flag user id so errors can be traced to a user.
listenerMiddleware.startListening({
  actionCreator: syncNativeAppContext.fulfilled,
  effect: (action) => {
    const userId = action.payload.featureFlagUser?.userId;
    if (userId) {
      void import('@datadog/browser-rum')
        .then(({ datadogRum }) => {
          datadogRum.setUser({ id: userId });
        })
        .catch(() => {
          // telemetry should never break the app
        });
    }
  },
});

listenerMiddleware.startListening({
  actionCreator: invalidate,
  effect: async (action, { dispatch }) => {
    await dispatch(syncNativeAppContext());
    dispatch(eCommApi.util.invalidateTags(['Cart']));
    dispatch(accountApi.util.invalidateTags(['Passes', 'Rewards']));
  },
});

listenerMiddleware.startListening({
  actionCreator: setUserDidDismissOnHoldAlertAction,
  effect: (action) => {
    TransientStorageService.setDidDismissOnHoldPassesAlert(action.payload);
  },
});
